import React from 'react';
import PropTypes from 'prop-types';
import TenantDescription from './TenantDescription';

const TenantMenuItem = ({
  name,
  regionName,
  regionCode,
  subscription,
  selected,
  url
}) => (
  <li className={`tenant-menu-item ${selected ? 'selected-tenant' : ''}`}>
    <a
      href={url}
      title={`${name} (${regionName})`}
      onClick={(e) => {
        e.preventDefault();
        window.location = `${url}&returnTo=${window.location.pathname}`;
      }}
    >
      <div className="tenant-name truncate">
        {name}
      </div>

      <TenantDescription
        regionCode={regionCode}
        regionName={regionName}
        subscription={subscription}
      />
    </a>
  </li>
);

TenantMenuItem.propTypes = {
  name: PropTypes.string.isRequired,
  regionName: PropTypes.string.isRequired,
  regionCode: PropTypes.string.isRequired,
  selected: PropTypes.bool.isRequired,
  url: PropTypes.string.isRequired,
  subscription: PropTypes.object
};

export default TenantMenuItem;
